/**
 * The section's contract service: spark-esign over http (`client.ts`), at `window.config.esignApiUrl`
 * read on every call (see `source.ts`). An absent `esignApiUrl` rejects every call, so the section
 * shows the Load failed notice and never fake states. The section receives this as its default
 * `service`; CT passes a fixture fake instead.
 */
import { download, fetchStatus, resend, restart, start } from './client';
import type { ContractService } from './contract';

export const contractService: ContractService = { fetchStatus, start, resend, restart, download };
